import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export const PENDING_VERIFICATION_EMAIL_KEY = 'pending_verification_email';
export const RESEND_COOLDOWN_SECONDS = 60;

export const savePendingVerificationEmail = (email) => {
  if (email) {
    sessionStorage.setItem(PENDING_VERIFICATION_EMAIL_KEY, email);
  }
};

export const getPendingVerificationEmail = () =>
  sessionStorage.getItem(PENDING_VERIFICATION_EMAIL_KEY) || '';

export const clearPendingVerificationEmail = () => {
  sessionStorage.removeItem(PENDING_VERIFICATION_EMAIL_KEY);
};

export const resendVerificationEmail = async (username) => {
  const response = await axios.post(
    `${API_BASE_URL}/users/resend_verification_email`,
    null,
    {
      params: { username },
      headers: { accept: 'application/json' },
    }
  );
  return response.data;
};

export const isUnverifiedLoginError = (error) => {
  const detail = error?.response?.data?.detail;
  return detail?.is_verified === false;
};

export const getUnverifiedLoginMessage = (error) => {
  const detail = error?.response?.data?.detail;
  return (
    detail?.message ||
    'Your email address has not been verified. Please verify your email before logging in.'
  );
};
